'use strict';

import NexusUI from './lib/main';

export default NexusUI;



// WEBPACK FOOTER //
// ./~/jshint-loader!./index.js